module.exports = __webpack_public_path__ + "img/224.726398e3.jpg";